const React = require('react')
const PropTypes = require('prop-types')
const isUser = require('module/user/helpers/is_user')
const isAdmin = require('module/viewer/helpers/is_admin')

function AdminButton(props, context) {
    const { viewer, page } = context

    if (page.id !== 'profile') return false
    if (! isAdmin(viewer)) return false
    if (isUser(viewer, page.user)) return false

    function onClick() {
        require.ensure([], () => {
            require('module/admin_flag/admin_flag')
            const radio = require('lib/radio')
            const user = radio.profile.request('user')
            radio.admin.request('admin:flag:ui', user)
        }, 'admin_flag')
    }

    return (
        <li className={props.className}>
            <button
                type="button"
                className="admin-button glyph-center glyph-flag"
                onClick={onClick}
                >
                &nbsp;
            </button>
        </li>
    )

}

AdminButton.propTypes = {
    className: PropTypes.string,
}
AdminButton.contextTypes = {
    page: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
}

module.exports = AdminButton
